import Button from "../ui/Button";
import { Link } from "react-router-dom";
import "./LandingHero.css";


function LandingHero() {
  return (
    <section className="landing-hero" id="home">
      <div className="landing-hero__inner">
        <div className="landing-hero__content">
          <h1 className="landing-hero__title">
            ContinuMee: het platform
            <br />
            voor continu onderzoek in
            <br />
            de publieke sector
          </h1>
          <p className="landing-hero__subtitle">
            Met ContinuMee krijgt u een doorlopend inzicht in de meningen, ervaringen en behoeften van uw klanten met uw dienstverlening.
          </p>
          <div className="landing-hero__actions">
            <Button variant="secondary">
              <span aria-hidden="true" className="landing-hero__play"></span>
              Video
            </Button>
            <Link to="/contact">
              <Button variant="primary">Boek een Demo</Button>
            </Link>
            
          </div>
        </div>

        <div className="landing-hero__media" aria-hidden="true">
          <img src="/hero-1.png" alt="" />
        </div>
      </div>
    </section>
  );
}

export default LandingHero;
